<div class="full-screen-wizard bg-color-admin scroll-y-auto welcome-wizard">
    <div class="text-white texto-welcome mb-4">
        <h1 class="texto-div-title">{{ 'app.wizard.selector.title' | translate }}</h1>
    </div>
    <div class="row justify-content-center">
        <div class="col-12 col-lg-3 mb-3 d-flex flex-column align-items-center">
            <div
                class="welcomecard flex-fill"
                [ngClass]="{ 'disabled-card': iaDisabled }"
                (click)="!iaDisabled && selectPath('ia')"
            >
                <img
                    style="width: 90%; height: auto"
                    src="{{ assetsUrl }}{{ mfsPath }}/img/front/wizard/welcome/wizard_ia.svg"
                    alt="wizard-img-ia"
                />
                <section class="mt-4">
                    <p style="font-weight: bold">{{ 'app.wizard.selector.genera_ia' | translate }}</p>
                    <p>{{ 'app.wizard.selector.obten_diseno' | translate }}</p>
                    <p>{{ 'app.wizard.selector.personalizado_en_segundos' | translate }}</p>
                </section>
            </div>
            <div *ngIf="iaDisabled" class="ia-legend">
                {{ 'app.producto.informacion_de_producto.ia_available_error' | translate }}
            </div>
        </div>
        <div class="col-12 col-lg-3 mb-3 d-flex justify-content-center">
            <div class="welcomecard" (click)="selectPath('initial')">
                <img
                    style="width: 90%; height: auto"
                    src="{{ assetsUrl }}{{ mfsPath }}/img/front/wizard/welcome/wizard_template.svg"
                    alt="wizard-img-ss"
                />
                <section class="mt-4">
                    <p style="font-weight: bold">{{ 'app.wizard.selector.personaliza_una_plantilla' | translate }}</p>
                    <p>{{ 'app.wizard.selector.explora_diversos' | translate }}</p>
                    <p>{{ 'app.wizard.selector.elige_uno' | translate }}</p>
                </section>
            </div>
        </div>
    </div>
</div>
